export const MESSAGES = {
    LOGIN_FAILED: 'Login Failed Please check your credentials',
    RESET_FAILED: 'There was an error. Please try again later.',
    SET_GOAL_FAILED: 'Updating your goal failed. Please try again.',
    SET_DETAILS_FAILED: 'Updating your details failed. Please try again.',
    LOAD_VIDEO_FAILED: 'Failed to fetch video details.',
    LOADING_ACCURACY: 'Our AI digital trainer is assessing the accuracy of your workout.Hang on.',
    SAVING_FEEDBACK: 'Saving your feedback. Please wait.',
    ENTER_REQUIRED_FIELDS: 'Please enter required fields',
    ENTER_CREDENTIALS: 'Please enter your credentials',
    ENTER_EMAIL: 'Please enter your email',
    ENTER_PASS : 'Please enter your password',
    ENTER_VALID_EMAIL: 'Please enter a valid email address',
    ENTER_VALID_OTP: 'Please enter a valid otp.',
    ENTER_EMAIL_ENDING: 'Access restricted to users with emails ending with',
    PASSWORD_UPDATED: 'Password updated successfully',
    PROFILE_DELETED: 'Profile deleted successfully',
    INCORRECT_EMAIL: 'Email entered is incorrect',
    SIGN_OUT_AND_SIGN_IN_AGAIN: 'Session has expired. Please sign out and sign in again to delete your account.',
    PROFILE_DELETED_FAILED: 'Profile not deleted. Please try again.',
    INCORRECT_PASSWORD: 'Current password is incorrect',
    PASSWORDS_NOT_MATCHING: "New password and confirm password don't match",
    SAME_OLD_PASSWORD: 'New password cannot be same as current password',
    ENTER_COMPLEX_PASSWORD: 'Your password did not meet our complexity requirements.',
    SET_GOAL: "Please set your goal in the next screen by pressing Ok button.",
    SAVE_GOAL: "Please save your goal details.",
    INVALID_AGE: "Please note age should be in between 3 to 100 years.",
    INVALID_WEIGHT: "Please note weight should be in between 5 to 300kgs.",
    DUPLICATE_USER_ERROR: "Email already registered.",
    DUPLICATE_USER_ERROR_MOBILE: "Mobile Number already registered.",
    PROFILE_UPDATED: "Profile updated successfully",
    INVALID_DATE: "Invalid Date of birth",
    UNREGISTERED_USER: "This email id is not registered. Please enter a valid email id",
    FIRST_NAME_ERROR: "Please note first name should be less than 15 characters.",
    LAST_NAME_ERROR: "Please note last name should be less than 15 characters.",
    ENTER_NAME: "Please enter the full name.",
    INVALID_GOAL_TIME: "Please note goal time should be in between 1 to 300 mins.",
    INVALID_GOAL_CAL: "Please note goal calories should be in between 1 to 5000 cal.",
    INVALID_GOAL_COUNT: "Please note goal workouts should be in between 1 and 100.",
    MESSAGE_LEN_EXCEEDED: "Please keep message below 500 words.",
    INVALID_MOBILE_NO: "Please enter a valid mobile no"
}
